"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HAS_IMAGE_FILTER = exports.AUTOFILL_FILTER = exports.MOBILE_FILTER = exports.NO_TEXT_FILTER = exports.DEFAULT_FILTER = exports.ORDER_FILTER = exports.EXCLUDE_PARTIAL_FILTER = exports.PARTIAL_FILTER = exports.LAST = exports.FIRST = exports.NONE = exports.ALL = void 0;
const AUTOFILL_LAYOUT_DESIGN_TAG = 'AutofillLayout';
const ensureTagsIsAnArray = tags => {
  if (!tags) {
    return [];
  }
  return Array.isArray(tags) ? tags : [tags];
};
exports.ALL = 'all';
exports.NONE = 'none';
exports.FIRST = 'first';
exports.LAST = 'last';
const PARTIAL_FILTER = d => d.coverage === 'partial';
exports.PARTIAL_FILTER = PARTIAL_FILTER;
const EXCLUDE_PARTIAL_FILTER = d => d.coverage !== 'partial';
exports.EXCLUDE_PARTIAL_FILTER = EXCLUDE_PARTIAL_FILTER;
const ORDER_FILTER = d => d.order ? true : false;
exports.ORDER_FILTER = ORDER_FILTER;
const DEFAULT_FILTER = d => d.default ? true : false;
exports.DEFAULT_FILTER = DEFAULT_FILTER;
const NO_TEXT_FILTER = d => {
  const tags = ensureTagsIsAnArray(d.tags);
  return tags.map(t => t.toLowerCase()).some(t => t.includes('no text'));
};
exports.NO_TEXT_FILTER = NO_TEXT_FILTER;
const MOBILE_FILTER = d => {
  const tags = ensureTagsIsAnArray(d.tags);
  const mobileTags = ['1 Image', '1 Images', '0 Image'];
  return tags.some(t => mobileTags.includes(t)) && (0, exports.NO_TEXT_FILTER)(d);
};
exports.MOBILE_FILTER = MOBILE_FILTER;
const AUTOFILL_FILTER = d => {
  const tags = ensureTagsIsAnArray(d.tags);
  return tags.includes(AUTOFILL_LAYOUT_DESIGN_TAG);
};
exports.AUTOFILL_FILTER = AUTOFILL_FILTER;
const HAS_IMAGE_FILTER = d => {
  const tags = ensureTagsIsAnArray(d.tags);
  return !tags.includes('No Image') && !(tags === null || tags === void 0 ? void 0 : tags.includes('0 Image'));
};
exports.HAS_IMAGE_FILTER = HAS_IMAGE_FILTER;